<script setup lang="ts">
  import { onMounted, useTemplateRef } from 'vue'
  import { IslandPublicView } from '~shared/types/island'

  const props = defineProps<{
    hostUsername: string
    island: IslandPublicView
  }>()

  const emit = defineEmits<{
    cancel: []
  }>()

  const rootEl = useTemplateRef<HTMLDivElement>('rootEl')

  onMounted(() => {
    rootEl.value?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
  })
</script>

<template>
  <div
    class="w-full max-w-2xl rounded-xl border border-red-400/80 bg-purple-500 p-8 text-white shadow-2xl"
    ref="rootEl"
  >
    <div class="flex h-full flex-col">
      <h2 class="font-display text-center text-3xl font-bold">Island Announcement</h2>

      <!-- Input Section -->
      <div class="mt-6 mb-8 flex flex-col items-center gap-4 text-center">
        <p>New announcement from {{ hostUsername }} on {{ island.name }}:</p>
        <p class="w-full text-lg text-white">
          {{ island.announcement }}
        </p>
      </div>
      <!-- Action -->
      <div class="flex justify-center">
        <button
          @click="emit('cancel')"
          class="bg-base-orange cursor-pointer rounded-lg px-8 py-2 font-bold text-black transition-colors hover:bg-red-500"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>
